import { createRoute } from "@tanstack/react-router";
import { Route as dashboardRoute } from "../../dashboard";
import ProjectDiscoveryPage from "@/components/project-discovery/ProjectDiscoveryPage";
import { $api } from "@/lib/api";

export const Route = createRoute({
  getParentRoute: () => dashboardRoute,
  path: "projects/$projectId",
  component: () => {
    const { projectId } = Route.useParams();
    return <ProjectDiscoveryPage key={projectId} projectId={projectId} />;
  },
  loader: ({ context, params }) => {
    if (!localStorage.getItem("backendToken")) return;
    const { projectId } = params;
    context.queryClient.prefetchQuery(
      $api.queryOptions("get", "/api/v1/projects/{project_id}", {
        params: { path: { project_id: projectId } },
      }),
    );
    context.queryClient.prefetchQuery(
      $api.queryOptions("get", "/api/v1/project-memory/{project_id}", {
        params: { path: { project_id: projectId } },
      }),
    );
    context.queryClient.prefetchQuery(
      $api.queryOptions("get", "/api/v1/projects/{project_id}/members", {
        params: { path: { project_id: projectId } },
      }),
    );
    context.queryClient.prefetchQuery(
      $api.queryOptions("get", "/api/v1/meetings/by-project/{project_id}", {
        params: { path: { project_id: projectId } },
      }),
    );
  },
});
